/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

function updateEngravingField() {
  document.querySelectorAll('.engraving-personalization').forEach((container) => {
    const productSection = container.closest('.shopify-section');
    if (!productSection) return;

    const input = container.querySelector('input.properties__input');
    if (!input) return;

    const selectedStyle = Array.from(
      productSection.querySelectorAll('input[type="radio"]:checked, select')
    ).map((element) => element.value).join(' ');

    const isPersonalized = selectedStyle.toLowerCase().includes('personalized');

    container.style.display = isPersonalized ? '' : 'none';
    input.required = isPersonalized;
    input.disabled = !isPersonalized;
  });
}

document.addEventListener('change', () => {
  requestAnimationFrame(updateEngravingField);
});

document.addEventListener('DOMContentLoaded', updateEngravingField);


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
